import React from "react";

interface AddToCalendarProps {
  title: string;
  startTime: string;
  endTime?: string | null;
  timezone?: string | null;
  locationName?: string | null;
  locationAddress?: string | null;
  description?: string | null;
  className?: string;
}

function formatICSDate(dateStr: string): string {
  const d = new Date(dateStr);
  return d
    .toISOString()
    .replace(/[-:]/g, "")
    .replace(/\.\d{3}/, "");
}

function stripHtml(html: string): string {
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
}

const AddToCalendar: React.FC<AddToCalendarProps> = ({
  title,
  startTime,
  endTime,
  locationName,
  locationAddress,
  description,
  className,
}) => {
  const handleClick = () => {
    const start = formatICSDate(startTime);
    const end = endTime
      ? formatICSDate(endTime)
      : formatICSDate(
          new Date(
            new Date(startTime).getTime() + 2 * 60 * 60 * 1000,
          ).toISOString(),
        );

    const location = [locationName, locationAddress].filter(Boolean).join(", ");
    const desc = description ? stripHtml(description).substring(0, 500) : "";

    const ics = [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//U.S. LawShield//Event//EN",
      "BEGIN:VEVENT",
      `DTSTART:${start}`,
      `DTEND:${end}`,
      `SUMMARY:${title}`,
      `LOCATION:${location}`,
      `DESCRIPTION:${desc}`,
      "END:VEVENT",
      "END:VCALENDAR",
    ].join("\r\n");

    const blob = new Blob([ics], { type: "text/calendar;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${title.replace(/[^a-zA-Z0-9]/g, "_")}.ics`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={
        className ||
        "text-[#C8102E] text-sm hover:underline inline-flex items-center gap-1"
      }
    >
      <svg
        className="w-4 h-4"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
        />
      </svg>
      Add to My Calendar
    </button>
  );
};

export default AddToCalendar;
